import React from 'react';
import { environment } from '../config/environment';

export const EnvironmentInfo: React.FC = () => {
  // Só mostrar em desenvolvimento
  if (!environment.isDevelopment) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 bg-gray-800 text-white text-xs px-3 py-2 rounded-lg shadow-lg z-50 opacity-75 hover:opacity-100 transition-opacity">
      <div className="font-semibold">{environment.name.toUpperCase()}</div>
      <div className="text-gray-300">API: {environment.apiBaseUrl}</div>
      <div className="text-gray-300">Vite Mode: {import.meta.env.MODE}</div>
    </div>
  );
};